import { map } from "rxjs";
import { Page } from "../../model";
import apiService from "../ApiService";

export const getAllBlacknutPlusGames = () => {
  return apiService
    .get<{ page: Page }>({
      path: "public/pages/games/bonusGame/true",
      edito: true,
    })
    .pipe(map(({ page }) => page));
};
